import React, { createContext, useContext, useEffect, useState } from "react";
import { Urls } from "./Urls";
import { auth } from "./Components/firebase/firebase";
import axios from "./Axios/Axios";

// Create a context for editable emails
export const EditbleEmailsContext = createContext({});

// Provider component for the editable emails context
export const EditbleEmailsProvider = ({ children }) => {
  // State to hold the email data
  const [emailData, setEmailData] = useState({});

  // Fetch email templates when the component mounts and user is authenticated
  useEffect(() => {
    if (auth && auth.currentUser && auth.currentUser.getIdToken()) {
      const payload = {
        "template_id_list": [
          "email_22", "email_23", "email_24", "email_66",
          "email_11", "email_12", "email_13", "email_63", "email_14", "email_78"
        ]
      };
      
      // Make a POST request to fetch email templates
      axios.post(`${Urls.email_template}template_id_list=true`, payload)
        .then((res) => {
          // Function to map email templates to specific keys
          const mapEmailTemplates = (templates) => {
            const mappedData = {};
            templates.forEach(template => {
              switch (template.template_id) {
                case 'email_22':
                  mappedData.liveTemplate = template;
                  break;
                case 'email_23':
                  mappedData.pauseTemplate = template;
                  break;
                case 'email_24':
                  mappedData.resumeTemplate = template;
                  break;
                case 'email_11':
                  mappedData.procureCreation = template;
                  break;
                case 'email_12':
                  mappedData.procureConclude = template;
                  break;
                case 'email_13':
                  mappedData.procureDelete = template;
                  break;
                case 'email_14':
                  mappedData.clientLive = template;
                  break;
                case "email_78":
                  mappedData.transporterAllocation = template;
                  break;
                default:
                  // Handle default case if needed
                  break
              }
            })
            return mappedData
          };

          // Map the fetched email templates and update state
          const emailTemplatesMap = mapEmailTemplates(res.data)
          setEmailData(emailTemplatesMap);
        })
        .catch((err) => {
          console.log(err, "error")
        })
    }
  }, []);

  return (
    <EditbleEmailsContext.Provider value={[emailData, setEmailData]}>
      {children}
    </EditbleEmailsContext.Provider>
  );
};

// Custom hook to access the editable emails context
export function useUser() {
  return useContext(EditbleEmailsContext)
}